import { createFileRoute } from '@tanstack/react-router'

import { CustomerDashboard } from '@/components/Customer/Dashboard'

export const Route = createFileRoute('/customer/dashboard')({
  component: CustomerDashboard,
})
